import { AccessLevels, ChannelVisibility } from "../../containers/channels/channelDetails/domain";
import miscUtils from "../../utils/miscUtils";

const FREE_PLAN_PRICE: number = 0;

export const pseudoChannel: any = {
    authorized_plans: [],
    authorized_segments: [],
    auto_join: false,
    channel_collection: null,
    channel_collection_id: null,
    cover_image: null,
    created_at: "2020-08-08 18:36:52",
    default: false,
    deleted_at: null,
    description: "",
    disable_comments_and_reactions: false,
    display_authorized_plans: false,
    emoji: null,
    exclude_in_weekly_digest: true,
    group_id: -1,
    has_pinned_post: false,
    hide_cover_image: false,
    id: -1,
    layout: "feed",
    lock_screen_active: false,
    lock_screen_btn_label: null,
    lock_screen_btn_url: null,
    lock_screen_instructions: null,
    members_count: 0,
    membership: null,
    name: "",
    position: -1,
    post_title_required: false,
    posting_permission: "members",
    requires_moderation: false,
    slug: "",
    status: "private",
    updated_at: "2022-08-08 12:51:44",
    visibility: "restricted",
    pseudo_channel: true,
}

export enum ChannelScreens {
    Posts = "posts",
    Courses = "courses",
    Events = "events",
}

export  const channelAccessRestricted = (channel: any, group: any) => {
    if (channel && channel.pseudo_channel) {
      return true;
    }

    //by access level
    if (channel && channel.status === AccessLevels.Plan) {
      return (
        !miscUtils.userIsOnResourcePlan(group.user_membership, channel.authorized_plans) && !miscUtils.isAdmin(group.user_membership) && !miscUtils.isChannelMember(group && group.user_membership, channel)
      )
    }

    if (channel && channel.status === AccessLevels.Segment) {
      return (
        !miscUtils.userIsOnResourseSegment(group.user_membership, channel.authorized_segments) && !miscUtils.isAdmin(group.user_membership) && !miscUtils.isChannelMember(group && group.user_membership, channel)
      )
    }

    if (channel && channel.status === AccessLevels.Paid) {
      if (
        group && !group.user_membership ||
        (
          group &&
          group.user_membership &&
          !group.user_membership.active_subscription &&
          !miscUtils.isTeamMember(group.user_membership)
        )
      ) {
        return true;
      }

      return (
        group &&
        group.user_membership &&
        group.user_membership.active_subscription &&
        group.user_membership.active_subscription.plan.price === FREE_PLAN_PRICE &&
        !miscUtils.isAdmin(group.user_membership) &&
        !miscUtils.isChannelMember(group && group.user_membership, channel)
      )
    }

    if (channel && channel.status === AccessLevels.Private) {
      return !miscUtils.isChannelMember(group && group.user_membership, channel) && !miscUtils.isAdmin(group.user_membership)
    }

    //by visibility settings
    if (channel && channel.visibility === ChannelVisibility.COMMUNITY) {
      return (!(
        group &&
        miscUtils.isActiveCommunityMember(group.user_membership)
      ))
    }

    if (channel && channel.visibility === ChannelVisibility.RESTRICTED) {
      return (
        !(miscUtils.isChannelMember(group && group.user_membership, channel) || miscUtils.isAdmin(group.user_membership))
      )
    }

    return false;
}